<div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
    <div class="field-fill-user-selector"  [ngClass]="{'invalid-field': (!valid && fieldSubmission.field.mandatory)}"
      *ngIf="items && items.length > 0; else loadingUsers">
      <core-helpers-forms-key-select
        [options]="items"
        [placeholder]="placeholder"
        (actionSelectItem)="onSelect($event)"
      ></core-helpers-forms-key-select>
    </div>

    <ng-template #loadingUsers>
    <div class="loader tags-lists">
      <div class="dimmed">
        <div class="dimmed_title"></div>
        <div class="dimmed_noflex">
          <div class="dimmed_subtitle"></div>
        </div>
      </div>
    </div>
    </ng-template>

</div>